import { memo } from "react";
import { fmt } from "@/lib/api";

export const tier = (m) => (m >= 10 ? "green" : m >= 5 ? "blue" : m >= 2 ? "cyan" : "grey");

export const TIERS = {
  grey: { frame: "#3a4257", inner: "#283043", top: "#6c7589", side: "#465066", label: "#b1bad3", pill: "#2f3547" },
  cyan: { frame: "#2a8d96", inner: "#1b4651", top: "#6ff0ee", side: "#2aa9b1", label: "#b8f4f4", pill: "#6fe3e3" },
  blue: { frame: "#1c62c7", inner: "#173867", top: "#6eaeff", side: "#2b6fd8", label: "#c5ddff", pill: "#3b8af0" },
  green: { frame: "#1a9b3d", inner: "#15462a", top: "#6ef58b", side: "#22ae4a", label: "#c6ffd2", pill: "#2fd35b" },
};

const SHAPES = {
  grey: "50,20 84,78 16,78",
  cyan: "50,14 86,50 50,86 14,50",
  blue: "50,14 86,40 73,82 27,82 14,40",
  green: "50,12 84,31 84,69 50,88 16,69 16,31",
};

const Shape = ({ t, active }) => {
  const c = TIERS[t];
  return (
    <svg viewBox="0 0 100 100" className="w-[70%] h-auto drop-shadow-[0_6px_6px_rgba(0,0,0,.35)]">
      <polygon points={SHAPES[t]} transform="translate(0,7)" fill={c.side} stroke={c.side} strokeWidth="12" strokeLinejoin="round" />
      <polygon points={SHAPES[t]} fill={active ? "#f4f8ff" : c.top} stroke={active ? "#f4f8ff" : c.top} strokeWidth="12" strokeLinejoin="round" />
    </svg>
  );
};

export const SlideCard = memo(({ m, active, dim, w, h }) => {
  const t = tier(m);
  const c = TIERS[t];
  return (
    <div
      className="shrink-0 rounded-xl p-[4px] transition-[opacity,transform] duration-300"
      style={{
        width: w,
        height: h,
        background: active ? "#9fb0c8" : c.frame,
        opacity: dim ? 0.42 : 1,
        transform: active ? "scale(1.06)" : "none",
        boxShadow: active ? "0 0 0 4px #ffffff, 0 10px 30px rgba(0,0,0,.45)" : "none",
      }}
    >
      <div className="rounded-lg h-full flex flex-col" style={{ background: active ? "#2e4357" : c.inner }}>
        <div className="flex-1 flex items-center justify-center">
          <Shape t={t} active={active} />
        </div>
        <div
          className="mx-1 mb-1 rounded-full text-center font-bold py-1 tabular-nums"
          style={{ background: "#121722", color: active ? "#fff" : c.label, fontSize: w < 100 ? 12 : 14 }}
        >
          {fmt(m)}×
        </div>
      </div>
    </div>
  );
});

export const HistoryPill = ({ m, win, testId }) => {
  const t = tier(m);
  const bg = win ? TIERS[t === "grey" ? "cyan" : t].pill : "#2f3547";
  return (
    <div
      data-testid={testId}
      className="shrink-0 rounded-full px-4 py-2 text-[14px] font-extrabold tabular-nums x-rise"
      style={{ background: bg, color: win ? "#0d1a22" : "#fff" }}
    >
      {fmt(m)}×
    </div>
  );
};
